import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const RegisterPrompt = () => {
  const navigate = useNavigate();

  return (
    <div className="w-full p-6 rounded-lg bg-muted/50 border border-border">
      <div className="text-center space-y-4">
        <p className="text-sm text-muted-foreground">
          Non hai ancora un account?
        </p>
        <Button
          variant="outline"
          size="default"
          onClick={() => navigate('/register')}
          iconName="UserPlus"
          iconPosition="left"
          className="w-full sm:w-auto"
        >
          Registrati ora
        </Button>
      </div>
    </div>
  );
};

export default RegisterPrompt;